export default {

    title: "Laden...",

    responses: {
        "404": {
            title: "Es ist ein Fehler aufgetreten",
            header: "Es ist ein Fehler aufgetreten",
            message: "Es wurde kein gültiges Token gefunden. Ihr Token ist möglicherweise abgelaufen."
        },
        "200_tfalogin": {
            title: "Anmeldebestätigung",
            header: "@:views.tunnel.service.response.200_tfalogin.title",
            message: "Anmeldung wurde verifiziert."
        },
        "404_tfalogin": {
            title: "Anmeldebestätigung",
            header: "@:views.tunnel.service.response.404_tfalogin.title",
            message: "Es wurde kein gültiges Token gefunden. Ihr Token ist möglicherweise abgelaufen."
        },
        "200_tfaaddress": {
            title: "Adressverifizierung",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Vielen Dank für die Bestätigung Ihrer Adresse. Sie können diese nun bei Ihrer Bestellung als Lieferadresse auswählen."
        },
        "404_tfaaddress": {
            title: "Adressverifizierung",
            header: "@:views.tunnel.service.response.404_tfaaddress.title",
            message: "Es wurde kein gültiges Token gefunden. Ihr Token ist möglicherweise abgelaufen."
        },
        "201_delivery": {
            title: "Danke",
            header: "Danke",
            message: "Vielen Dank für Ihre Antwort."
        },
        "201_shipment_received": {
            title: "Danke",
            header: "Danke",
            message: "Vielen Dank für Ihre Antwort."
        },
        "400": {
            title: "Fehlerhafte Anfrage. Es ist ein Fehler aufgetreten.",
            header: "@:views.tunnel.service.response.400.title",
            message: "Fehlerhafte Anfrage. Es ist ein Fehler aufgetreten."
        }
    }
}